import React from 'react'

import { useIncidentList } from '../hooks'

import Header from '../../common/components/Header'
import IncidentListItem from './IncidentListItem'

import styles from './IncidentList.module.css'

const IncidentList = () => {
  const [{ incidentIds, isLoading }] = useIncidentList()

  return (
    <div>
      <Header>
        {incidentIds.length} Incidents{' '}
        {isLoading && <i className="fa fa-spinner fa-spin"></i>}
      </Header>
      <ul className={styles.list}>
        {incidentIds.map((incidentId, i) => (
          <IncidentListItem incidentId={incidentId} key={i} />
        ))}
      </ul>
    </div>
  )
}

export default IncidentList
